









import Vue, { PropType } from "vue";
import log from "loglevel";
import { UpdateContractResponse } from "@/containers/cloudCancelContractButton/api";

export interface CloudContractButtonProps {
  returnUrl: string;
  errorUrl: string;
  caption: string;
  contractNumber: string;
  updateContract: any;
  updateIsBusy: any;
}

export interface CloudContractButtonData {
  isError: boolean;
  errorMessage: string;
}

export default Vue.extend({
  name: "vc-cloud-cancel-contract-button",

  data(): CloudContractButtonData {
    return {
      isError: false,
      errorMessage: ""
    };
  },

  props: {
    returnUrl: {
      type: String as PropType<CloudContractButtonProps["returnUrl"]>,
      default: ""
    },
    errorUrl: {
      type: String as PropType<CloudContractButtonProps["errorUrl"]>,
      default: ""
    },
    caption: {
      type: String as PropType<CloudContractButtonProps["caption"]>,
      default: ""
    },
    contractNumber: {
      type: String as PropType<CloudContractButtonProps["contractNumber"]>,
      default: ""
    },
    //actionsToProps
    updateContract: {
      type: Function as PropType<CloudContractButtonProps["updateContract"]>,
      default: () => {}
    },
    //mutationsToProps
    updateIsBusy: {
      type: Function as PropType<CloudContractButtonProps["updateIsBusy"]>,
      default: () => {}
    }
  },

  methods: {
    async SendCancellationData() {
      this.updateIsBusy(true);
      const params = {
        contractNumber: this.contractNumber
      };
      try {
        const res: UpdateContractResponse = await this.updateContract(params);
        window.location.href =
          res && res.status === "success"
            ? this.returnUrl
            : this.errorUrl + "?messageType=" + res.message_type;
      } catch (error) {
        log.error(error);
        window.location.href = this.errorUrl + "?messageType=default_error";
        throw error;
      } finally {
        this.updateIsBusy(false);
      }
    }
  }
});
